module.exports = __webpack_public_path__ + "static/media/money-bag-filled.942aa12a.svg";